<template>
  <div>
    <!--切换的 tab  v-if="allTabs"-->
    <!--    <div class="step-box flex" >-->
    <!--      <div v-for="(item,index) in stepData" :key="index">-->
    <!--        <div class="step-content border-right" :class="{-->
    <!--                    'border-right': stepData.length === 1 && index ===0 || stepData.length === 2 && index === 1,-->
    <!--                    'active-item':activeIndex === index,-->
    <!--                    'border-bottom':activeIndex === 1}"-->
    <!--             @click="handleActive(index)">{{item}}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="margin-b10">
      <eui-btn type="secondary" @click="$router.go(-1)">&lt; 返回</eui-btn>
    </div>
    <div class="tab-wrapper flex" :class="{ 'bg-white': true }">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        class="info-wrapper"
        style="flex-shrink: 0"
        :class="{ 'active-item': item.orderReceiveId === activeItem }"
        @click="changeActive(item)"
      >
        <!--            <e-tooltip :content="item.orderShipmentName" :set-length="31" />-->
        <div class="break">{{ item.orderShipmentName }}</div>
        <div class="triangle" v-if="item.orderReceiveId === activeItem"></div>
      </div>
    </div>

    <div class="receipt-detail margin-b10">
      <ul>
        <li>
          <div class="detail-title margin-b10">发货单详情</div>
          <el-form label-width="120px">
            <el-row>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="发货单名称:" prop="pass">
                  {{ detailInfo.orderShipmentName }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="订单编号:" prop="pass">{{
                  detailInfo.orderNo
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="状态:" prop="pass">
                  {{ showStatus }}
                  <span
                    style="color: #2d8cf0; cursor: pointer"
                    class="margin-l20"
                    v-if="Number(detailInfo.transportType) === 4"
                    @click="toEwuLiu"
                    >到易物流揭示报价并委托物流</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="发货单编号:" prop="pass">
                  {{ detailInfo.orderReceiveId }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="期望到货日期:" prop="pass">
                  {{
                    detailInfo.arriveTimeTxt
                      ? detailInfo.arriveTimeTxt.split(' ')[0]
                      : ''
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="买方企业名称:" prop="pass">
                  {{ detailInfo.purchaseCompany }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="height: 30px">
                <el-form-item label="发货日期:" prop="pass">
                  {{
                    detailInfo.deliverTimeStr
                      ? detailInfo.deliverTimeStr.split(' ')[0]
                      : ''
                  }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </li>
      </ul>
      <order-map
        v-if="
          JSON.stringify(logisticsObj) !== '{}' &&
          ewuliuMapUrl != '' &&
          logisticsObj.deliveryWay !== 0 &&
          logisticsObj.transportType !== 1
        "
        :ewuliuMapUrl="ewuliuMapUrl"
        :deliveryInfo="logisticsObj"
        :receiveOrderData="detailInfo"
      ></order-map>
      <div class="delivery-method" v-else>
        <div class="delivery">
          <div class="left">
            <div class="detail-title">
              配送方式
              <span class="des-title">
                <!-- {{ logisticsObj.deliveryWay == 0 ? "(自行配送)" : "(第三方物流配送)" }} -->
                {{ `(${detailInfo.transportTypeDesc})` }}
                <!-- {{ modeObj[logisticsObj.deliveryWay] }} -->
              </span>
            </div>
            <div class="detail">
              <!--  0-自配、1-第三方、2-其他 其他目前没有没有-->
              <div class="title" v-if="logisticsObj.deliveryWay !== 0">
                <span class="item-title">物流公司：</span>
                <span class="item-content">{{
                  logisticsObj.expressCompanyName
                }}</span>
              </div>
            </div>
            <div class="detail" v-if="logisticsObj.deliveryWay == 0">
              <div class="title">
                <span class="item-title">送货人：</span>
                <span class="item-content">{{ detailInfo.deliName }}</span>
              </div>
              <div class="title" style="margin-top: 10px">
                <span class="item-title"> 联系电话：</span>
                <span class="item-content">{{ detailInfo.deliPhone }}</span>
              </div>
              <div class="title" style="margin-top: 10px">
                <span class="item-title"> 车牌号：</span>
                <span class="item-content">{{
                  detailInfo.licensePlateNumber
                }}</span>
              </div>
            </div>
            <div class="detail" v-if="logisticsObj.deliveryWay != 0">
              <div class="title">
                <span class="item-title">{{
                  logisticsObj.transportType == 1 ? '快递单号：' : '物流单号：'
                }}</span>
                <span class="item-content">
                  {{
                    logisticsObj.transportType == 1
                      ? logisticsObj.billNo
                      : logisticsObj.logisticsNo
                  }}
                </span>
              </div>
              <!--          <div class="content" >{{logisticsObj.billNo}}</div>-->
            </div>
            <div class="detail">
              <div class="title">
                <span class="item-title"> 发货备注：</span>
                <span class="item-content">无</span>
              </div>
            </div>
            <div
              class="attachment"
              v-if="
                detailInfo.listAttachment &&
                detailInfo.listAttachment.length > 0
              "
            >
              <div class="detail">
                <span class="item-title">附件：</span>
              </div>
              <div class="flex">
                <div class="attach-box margin-t10" v-if="listAttachment.length > 0">
                  <div class="attach-left">
                    <a target="_blank" :href="listAttachment[0].url">
                      <eui-tooltip-over class="file-name" :tooltipStyle="{ 'width': '130px' }"
                                        :content="listAttachment[0].name">
                        <span id="attachment">{{listAttachment[0].name}}</span>
                      </eui-tooltip-over>
                    </a>
                    <div class="margin-t4">
                      <div class="label-item" v-if="listAttachment[0].tags">{{listAttachment[0].tags}}</div>
                    </div>
                  </div>
                </div>
                <eui-link lighten font-size="12px" v-if="listAttachment.length > 1" @click="labelVisible = true"> 查看更多
                </eui-link>

              </div>
            </div>
          </div>
          <div class="middle">
            <iframe
              style="width: 100%; height: 202px; margin-left: 16px"
              :src="kdnMapUrl"
              frameborder="0"
            ></iframe>
          </div>
          <div class="right">
            <el-row
              v-for="(item, index) in logisticsTrackVOs"
              :key="index"
              class="row"
            >
              <el-col :span="6">
                <div class="date">{{ item.eventTime }}</div>
              </el-col>
              <!--          <el-col :span="3"><div class="time">{{ item.time }}</div></el-col>-->
              <el-col :span="2" class="img">
                <img
                  :src="
                    item.statusCodeStr == '已签收'
                      ? img.complete
                      : index == 0
                      ? img.transformActive
                      : img.transform
                  "
                />
                <div
                  :class="{
                    'last-line': index == logisticsTrackVOs.length - 1,
                    line: index != logisticsTrackVOs.length - 1,
                  }"
                ></div>
              </el-col>
              <el-col :span="13">
                <div class="title">{{ item.statusCodeStr }}</div>
                <div
                  class="content"
                  v-if="
                    logisticsObj.deliveryWay == 0 ||
                    logisticsObj.deliveryWay == 1
                  "
                >
                  于 {{ item.eventAddress }} {{ item.linkmanName }}
                  {{ item.linkmanMobile }}
                </div>
                <div class="content" v-else>{{ item.eventDesc }}</div>
              </el-col>
            </el-row>
            <div v-if="noFlag" class="no-logistics">
              <img src="@/assets/img/orderDetail/no-logistics.svg" alt />
              <div>暂无物流信息</div>
            </div>
          </div>
        </div>
        <div class="tip-wrap">
          <div class="red">提示：</div>
          <div class="content" style="padding: 0">
            <p>
              易派客平台仅作为物流相关信息的展示方，提供物流数据展示服务，具体运输商资质、物流合同洽谈与签署、物流报价、物流时效、违约等有关
            </p>
            <p>物流实际运作相关的信息与事项，请您与您的合作运输商沟通确认。</p>
          </div>
        </div>
      </div>
      <div class="tip">收货清单</div>
      <div class="tip-wrap">
        <div class="red">提示：</div>
        <div class="content" style="padding: 0">
          收货时，若发现货物破损、遗失，或任何需要供应商补货的情况，请先完成此次收货，然后提出售后补货申请。
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-top: 10px"
        :header-cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          min-width="220"
          prop="productName"
          label="商品名称"
          align="left"
        >
          <template slot-scope="scope">
            <e-tooltip :content="scope.row.productName" :set-length="26" />
          </template>
        </el-table-column>
        <!--      <el-table-column-->
        <!--        min-width="80"-->
        <!--        prop="brandName"-->
        <!--        label="品牌"-->
        <!--        align="left"-->
        <!--      ></el-table-column>-->
        <el-table-column
          prop="productSkuCode"
          label="商品编码"
          align="left"
          min-width="110"
        >
          <template slot-scope="scope">
            <e-tooltip :content="scope.row.productSkuCode" :set-length="24" />
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsQuantity"
          label="下单数量"
          align="left"
          min-width="70"
        ></el-table-column>
        <el-table-column label="发货数量" min-width="0" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.deliveryQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="溢装率"
          min-width="70"
          align="center"
          v-if="detailInfo.hasOverShipment === 1"
        >
          <template #default="{ row }">
            <span>{{ `${row.overShipmentRate * 100}%` }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计量单位"
          prop="goodsUnitName"
          width="80"
          align="center"
        >
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <div class="flex-sb">
      <eui-btn type="secondary" @click="$router.go(-1)">&lt; 返回</eui-btn>
      <eui-btn
        type="primary"
        @click="delInvoiceItem"
        v-if="
          detailInfo.shipStatus === 0 ||
          (detailInfo.shipStatus === -1 && activeData.inquiryStatus === 2)
        "
        >删 除</eui-btn
      >
    </div>
    <!-- 多个附件弹框-->
    <show-file-dialog
            v-if="labelVisible"
            :labelVisible.sync="labelVisible"
            :attachList="listAttachment"
    />
  </div>
</template>

<script>
import api from '../../api/order';
import eTooltip from '../../components/common/e-tooltip';
import orderMap from './components/orderMap.vue';
import { ewuliuGateway } from '@/modules/projectA/api/config';
import showFileDialog from './common/showFileDialog';

export default {
  data() {
    return {
      showStatus: '',
      stepData: [],
      activeIndex: 0,
      allTabs: false,
      purchaseCompanyId: '',
      activeItem: '',
      activeData: {},
      menuList: [],
      unShippedData: [], //0：已发货 即待收货；
      receiptCompletedData: [], //1：已收货 即 收货完成
      DURATIONTIME: 5000,
      img: {
        complete: require('@/assets/img/orderDetail/complete.png'),
        transform: require('@/assets/img/orderDetail/transform.png'),
        transformActive: require('@/assets/img/orderDetail/transform-active.png'),
      },
      steps: [
        {
          date: '2021-05-26/周三',
          time: '20:11:03',
          title: '已签收',
          content: '您的订单已经由本人签收',
        },
        {
          date: '2021-05-26/周三',
          time: '20:11:03',
          title: '运输中',
          content:
            '您的订单已经由本人签收您的订单已经由本人签收您的订单已经由本人签收',
        },
        {
          date: '2021-05-26/周三',
          time: '20:11:03',
          title: '运输中',
          content:
            '您的订单已经由本人签收您的订单已经由本人签收您的订单已经由本人签收',
        },
      ],
      active: 0,
      tableData: [],
      total: 0,
      listQuery: {
        orderReceiveId: '',
        purchaseCompanyId: '',
        pageNum: 1,
        pageSize: 10,
      },
      checked: false,
      detailInfo: {},
      listAttachment: [],
      labelVisible: false,
      shipmentVO: Object,
      submitFlag: false,
      listReceiveItem: [],
      orderIdTrue: '',
      logisticsTrackVOs: [],
      logisticsObj: {},
      noFlag: false,

      modeObj: {
        0: '(自行配送)',
        2: '(第三方物流)',
        4: '(询比价)',
      },
      ewuliuMapUrl: '',
      kdnMapUrl: '',
    };
  },
  components: {eTooltip, orderMap, showFileDialog},
  methods: {
    //处理文件名称过长问题
    dealAttachmentName(attachmentName) {
      if (attachmentName.length > 6) {
        let preName = attachmentName.substr(0, 3);
        let lastName = attachmentName.substring(
          attachmentName.lastIndexOf('.') - 2
        );
        return preName + '...' + lastName;
      } else {
        return attachmentName;
      }
    },
    delInvoiceItem() {
      this.$confirm(
        '您正在删除发货单，删除后将返回待发货数量，是否确认？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          api
            .removeShipInfo({
              orderReceiveId: this.activeItem,
              purchaseCompanyId: this.purchaseCompanyId,
            })
            .then((res) => {
              if (res.success) {
                this.$message({ type: 'success', message: '删除发货单成功!' });
                this.spplierShipList(); //查询列表  shipStatus   0：已发货 即待收货；  1：已收货 即 收货完成
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        });
    },
    toEwuLiu() {
      if (process.env.NODE_ENV === 'production') {
        window.open(
          `https://ewuliu-supplier.epec.com/#/order/inquiry?orderCode=${this.logisticsObj.logisticsNo}`,
          '_blank'
        );
      } else {
        window.open(
          `https://dev-a-ewuliu-supplier.epec.com/#/order/inquiry?orderCode=${this.logisticsObj.logisticsNo}`,
          '_blank'
        );
      }
    },
    status() {
      const { isOnLinePay, companyPayType } = this.$route.query;
      if (this.detailInfo.shipStatus === 0) {
        this.showStatus = '待收货';
      }
      // 已收货
      if (this.detailInfo.shipStatus === 1) {
        if (Number(isOnLinePay) === 1 && Number(companyPayType) === 1) {
          //判断是不是 在线支付 担保支付
          //0：货款待解冻  7、 货款解冻成功 8、货款解冻失败 6 货款解冻中        0和8一样
          if (
            this.detailInfo.paymentStatus === 0 ||
            this.detailInfo.paymentStatus === 8
          ) {
            this.showStatus = '货款待解冻';
          } else if (this.detailInfo.paymentStatus === 7) {
            this.showStatus = '完成收货';
          } else {
            this.showStatus = '货款解冻中';
          }
        } else {
          this.showStatus = '完成收货';
        }
      }
      if (this.detailInfo.shipStatus === -1) {
        // 询价状态 0：询价中 1：询价成功  2：询价失败
        if (this.activeData.inquiryStatus === 0) {
          this.showStatus = '询价中';
        } else if (this.activeData.inquiryStatus === 1) {
          this.showStatus = '询价成功';
        } else if (this.activeData.inquiryStatus === 2) {
          this.showStatus = '询价失败';
        }
      }
    },
    //切换tab
    handleActive(val) {
      //只有一个tab标签 不用点击
      if (!this.allTabs) {
        return false;
      }

      this.activeIndex = val;
      if (val) {
        //已确认收货
        this.menuList = this.receiptCompletedData;
        this.activeItem = this.receiptCompletedData[0].orderReceiveId;
        this.listQuery.orderReceiveId =
          this.receiptCompletedData[0].orderReceiveId;
      } else {
        this.menuList = this.unShippedData;
        this.activeItem = this.unShippedData[0].orderReceiveId;
        this.listQuery.orderReceiveId = this.unShippedData[0].orderReceiveId;
      }
      this.selectShipDetail();
    },
    changeActive(item) {
      //只有一条数据不用点击
      if (this.menuList.length === 1) {
        return false;
      }
      this.activeItem = item.orderReceiveId;
      this.activeData = item;
      this.listQuery.orderReceiveId = item.orderReceiveId;
      this.selectShipDetail();
    },
    async getDetailInfo() {
      this.listAttachment = [];
      const { supplierShipDetail, queryLogisticsList } = api;
      const res = await supplierShipDetail(this.listQuery);
      if (res.code === '200') {
        this.detailInfo = { ...res.data };
        this.detailInfo.listAttachment.forEach(item => {
          this.listAttachment.push({
            name: item.attachmentName,
            url: item.attachmentUrl,
            tags: item.tags
          })
        })

        this.status();
      }

      let resData = await queryLogisticsList({
        orderId: this.$route.query.orderId,
        supplierId: this.detailInfo.supplierCompanyId,
        orderShipmentId: this.listQuery.orderReceiveId,
        flag: 'DESC',
      });
      if (resData.code == '200') {
        // console.log(resData.data, " resData.data");
        this.logisticsObj = resData.data[0] || {};

        this.logisticsTrackVOs = resData.data[0]?.logisticsTrackVOs;
        this.kdnMapUrl =
          this.logisticsTrackVOs && this.logisticsTrackVOs.length > 0
            ? this.logisticsTrackVOs[0].mapUrl +
              '&height=100vh&width=100%25&noresize=true&nocopy=true'
            : '';
        this.getEwuliuMapUrl();
        if (!this.logisticsTrackVOs || this.logisticsTrackVOs.length === 0) {
          this.noFlag = true;
        } else {
          this.noFlag = false;
        }
      }
    },
    async getList() {
      const { supplierShipItemList } = api;
      const res = await supplierShipItemList(this.listQuery);
      const data = res.data;
      this.tableData = [...data.records];
      this.total = data.total;
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList();
    },
    //初始化查询 所有 发货单   查询列表  shipStatus   0：已发货 即待收货；  1：已收货 即 收货完成
    async spplierShipList(shipStatus) {
      let params = {
        orderId: this.$route.query.orderId,
        purchaseCompanyId: this.purchaseCompanyId,
        pageNum: 1,
        pageSize: 9999,
      };
      const res = await api.spplierShipList(params);
      if (res.success) {
        // if(shipStatus){//1：已收货 即 收货完成
        //   this.receiptCompletedData = res.data.records;
        // }else{// 0：已发货 即待收货
        //   this.unShippedData = res.data.records;
        //   this.dealData();
        // }
        this.menuList = res.data.records;
        this.listQuery.orderReceiveId = this.menuList[0].orderReceiveId;
        this.listQuery.purchaseCompanyId = this.purchaseCompanyId;
        this.activeItem = this.listQuery.orderReceiveId;
        this.activeData = this.menuList[0];
        if (this.listQuery.orderReceiveId) {
          this.selectShipDetail();
        }
      }
    },
    //全有数据 之后 得 处理
    dealData() {
      if (
        this.receiptCompletedData.length > 0 &&
        this.unShippedData.length > 0
      ) {
        //都有数据
        this.allTabs = true;
        this.listQuery.orderReceiveId = this.unShippedData[0].orderReceiveId;
        this.menuList = this.unShippedData;
        this.stepData = ['待收货', '收货完成'];
      } else if (
        this.receiptCompletedData.length > 0 &&
        this.unShippedData.length === 0
      ) {
        //只有收货完成 即已确认收货
        this.allTabs = false;
        this.listQuery.orderReceiveId =
          this.receiptCompletedData[0].orderReceiveId;
        this.menuList = this.receiptCompletedData;
        this.stepData = ['收货完成'];
      } else if (
        this.receiptCompletedData.length === 0 &&
        this.unShippedData.length > 0
      ) {
        // 只有 已发货 即待确认收货
        this.allTabs = false;
        this.listQuery.orderReceiveId = this.unShippedData[0].orderReceiveId;
        this.menuList = this.unShippedData;
        this.stepData = ['待收货'];
      }
      this.listQuery.purchaseCompanyId = this.purchaseCompanyId;
      this.activeItem = this.listQuery.orderReceiveId;
      this.selectShipDetail();
    },
    //查询 点击 的 详情
    selectShipDetail() {
      this.getDetailInfo();
      this.getList();
    },
    //获取易物流地图
    async getEwuliuMapUrl() {
      const res = await api.getEwuliuMapToken();

      if (res.code === '200') {
        let token = res.data;
        let fhdh = this.logisticsObj.logisticsNo;
        console.log(token, 'parent');
        console.log(fhdh, 'parent');
        this.ewuliuMapUrl = `${ewuliuGateway}/#/nbOrder/transferInfo?pageType=byDeliverCode&deliverCode=${fhdh}&token=${token}`;
        this.$set(this, 'ewuliuMapUrl', this.ewuliuMapUrl);
        console.log(this.ewuliuMapUrl, 'parent');
      }
    },
  },
  created() {
    this.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.spplierShipList(); //查询列表  shipStatus   0：已发货 即待收货；  1：已收货 即 收货完成
    // setTimeout(() => {
    //   this.spplierShipList(0);//查询列表  shipStatus   0：已发货 即待收货；  1：已收货 即 收货完成
    // }, 1000)
  },
};
</script>

<style scoped lang="scss">
@import '../../../../assets/css/table';
.tab-wrapper {
  width: 100%;
  overflow-x: auto;
  .info-wrapper {
    width: 158px;
    height: 50px;
    border: 1px solid #666;
    background-color: #fff;
    margin-right: 10px;
    padding: 10px;
    font-size: 12px;
    cursor: pointer;
    position: relative;
    .break {
      width: 136px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .triangle {
      position: absolute;
      box-sizing: border-box;
      width: 17px;
      height: 17px;
      top: 0;
      right: 0;
      border-top: 17px solid #2587ff;
      border-left: 17px solid transparent;
    }
  }
  .active-item {
    border: 1px solid #2587ff;
  }
}
.bg-white {
  padding: 12px 10px;
  background-color: #fff;
  width: 100%;
}
.step-box {
  .step-content {
    width: 148px;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    text-align: center;
    border: 1px solid #d9d9d9;
    border-right: none;
    cursor: pointer;
  }

  .border-right {
    border-right: 1px solid #d9d9d9;
  }

  .border-bottom {
    border-bottom: none;
  }

  .active-item {
    border-top: 2px solid #2587ff;
    background: #f4f7ff;
    color: #2587ff;
    height: 40px;
    border-bottom: none;
  }
}

.receipt-detail {
  padding: 10px;
  background: #fff;
  margin-top: 10px;
  .pagination-box {
    margin-top: 20px;
    text-align: right;
  }

  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }

    .handle {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-left: 4px;
      }

      .confirm {
        width: 100px;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
        background: #2587ff;
        &:hover {
          background-color: #126edf;
        }
      }
    }
  }

  .margin {
    margin-top: 20px;
  }

  .input-item {
    ::v-deep .el-input__inner {
      border-color: transparent;
      &:focus {
        border-color: #2587ff;
      }
    }
  }
  .tip {
    width: 96px;
    height: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 16px;
    margin: 20px 0 10px 0;
  }

  ul {
    display: flex;
    margin-top: 10px;
    li {
      width: 100%;
      height: 192px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      margin-left: 10px;
      padding: 14px 20px 0;

      &:first-child {
        margin-left: 0;
      }
    }
  }
  .tip-wrap {
    display: flex;
    background-color: #e8efff;
    padding: 10px 20px;
    margin-top: 10px;
    font-size: 14px;
    .red {
      color: #ef4c56;
      display: inline-block;
    }
  }
  .delivery-method {
    margin-top: 10px;
    border: 1px solid #d9d9d9;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .delivery {
      max-height: 266px;
      display: flex;
      .left {
        width: 306px;
        padding-right: 20px;
        border-right: 1px solid #d9d9d9;
      }
      .item-content {
        margin-top: 10px;
        font-size: 12px;
        color: #333;
      }
      .item-title {
        display: inline-block;
        width: 66px;
        text-align: right;
        color: #999;
      }
      .middle {
        width: 30%;
      }
      .right {
        width: 40%;
        padding: 5px 20px;
        height: 220px;
        overflow-y: auto;
        .row {
          margin-bottom: 9px;
          min-height: 50px;
          ::v-deep .el-col-13 {
            width: 59%;
          }
        }
        .img {
          position: relative;
          img {
            width: 24px;
          }

          .last-line {
            position: absolute;
            height: 70px;
            border: 1px solid #d9d9d9;
            top: 24px;
            left: 12px;
            &::after {
              position: absolute;
              content: '';
              width: 6px;
              height: 6px;
              background: #999999;
              bottom: 0;
              border-radius: 50%;
              right: -3px;
            }
          }
          .line {
            position: absolute;
            height: 130px;
            border: 1px solid #d9d9d9;
            top: 24px;
            left: 12px;
            background-color: #d9d9d9;
          }
        }
        .no-logistics {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          img {
            width: 120px;
          }
        }
      }
    }
  }

  .bill {
    margin-top: 8px;
    color: #0064c8;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    flex-wrap: wrap;
    flex-basis: 49%;
    width: 105px;
    .notice {
      display: inline-block;
      cursor: pointer;
      border-bottom: 1px solid transparent;
      color: #0064c8;
      &:hover {
        border-bottom: 1px solid #0064c8;
      }
    }
  }

  .detail-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .des-title {
    font-weight: normal;
    margin-left: 10px;
  }
  .attachment {
    display: flex;
    // justify-content: flex-start;
    // flex-wrap: wrap;
    .flex {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      flex-basis: 85%;
      width: 100%;
    }
  }

  .attach-box {
    width: 100%;
    height: 60px;
    padding: 6px 10px 10px 10px;
    background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);
    margin-bottom: 6px;

    .attach-left {
      .margin-t4 {
        margin-top: 4px;
      }

      .label-item {
        width: 64px;
        height: 20px;
        border: 1px solid #D9D9D9;
        margin-right: 6px;
        color: #666;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        background-color: #fff;

        &:hover {
          background-color: #e9f3ff;
          border-color: #2587FF;
          color: #2587FF;
        }
      }
    }

    .file-name {
      color: #0064C8;
      cursor: pointer;
      font-size: 14px;
      margin-top: 2px;
    }
  }
  .detail {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    .title {
      color: #999;
    }
    .content {
      margin-top: 10px;
      font-size: 12px;
      color: #333;
    }
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2587ff;
    border-color: #2587ff;
  }
  ::v-deep .el-checkbox__inner::after {
    border-left: 0;
    border-top: 0;
  }
}
</style>
